import { RoleEnum } from 'scalis-db-v2'

export const OrganizationRole = {
  SUPER_ADMIN: RoleEnum.SUPER_ADMIN,
  ADMIN: RoleEnum.ADMIN,
  MEMBER: RoleEnum.MEMBER,
  GUEST: RoleEnum.GUEST,
} as const

export const JobLevelRole = {
  RECRUITER: RoleEnum.RECRUITER,
  HIRING_MANAGER: RoleEnum.HIRING_MANAGER,
  TEAM_MEMBER: RoleEnum.HIRING_TEAM_MEMBER,
  VIEWER: RoleEnum.JOB_VIEWER,
} as const

export enum RaceEthnicity {
  HISPANIC_OR_LATINO = 'HISPANIC_OR_LATINO',
  WHITE = 'WHITE',
  BLACK_OR_AFRICAN_AMERICAN = 'BLACK_OR_AFRICAN_AMERICAN',
  NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER = 'NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER',
  ASIAN = 'ASIAN',
  AMERICAN_INDIAN_OR_ALASKA_NATIVE = 'AMERICAN_INDIAN_OR_ALASKA_NATIVE',
  TWO_OR_MORE_RACES = 'TWO_OR_MORE_RACES',
  DECLINE_TO_SELF_IDENTIFY = 'DECLINE_TO_SELF_IDENTIFY',
}
